export default __webpack_public_path__ + "static/media/2.25943084.png";